/**
 * CollectionReconReport.jsx — Standalone page for the Collection &
 * Reconciliation Report. Accessible to both `school_admin` and `cashier`
 * (both roles perform daily accounts closing in this ERP).
 *
 * READ-ONLY: This module only downloads reports — it can neither modify
 * nor delete any payment or reconciliation data. All mutation endpoints
 * remain restricted to the roles they were before Phase 30L.
 */
import React from "react";
import { Receipt } from "@phosphor-icons/react";
import CollectionReconReportCard from "@/pages/schooladmin/CollectionReconReportCard";

export default function CollectionReconReport() {
  return (
    <div className="space-y-6" data-testid="collection-recon-page">
      <div>
        <div className="text-[10px] uppercase tracking-[0.2em] font-semibold text-slate-500">
          Accounts
        </div>
        <h1 className="text-3xl font-bold tracking-tight text-slate-900 font-heading mt-1 flex items-center gap-2">
          <Receipt size={28} weight="duotone" />
          Collection &amp; Reconciliation Report
        </h1>
        <p className="text-sm text-slate-600 mt-1">
          Download a period-scoped fee-collection register for daily accounts
          closing and end-of-day reconciliation.
        </p>
      </div>
      <CollectionReconReportCard />
    </div>
  );
}
